'use client'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cn } from '@tebuto/lib/utils'
import { Check } from 'lucide-react'
import * as React from 'react'

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            'grid place-content-center peer h-4 w-4 shrink-0 rounded border border-gray-300 bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-brand/20 focus-visible:border-primary-brand disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-brand data-[state=checked]:border-primary-brand data-[state=checked]:text-white',
            className
        )}
        {...props}
    >
        <CheckboxPrimitive.Indicator className={cn('grid place-content-center text-current')}>
            <Check className="h-3 w-3" strokeWidth={3} />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
